export class ChurnTemplateConstants {
}
ChurnTemplateConstants.RiskSummaryOutput = 'Risk Summary';
ChurnTemplateConstants.RiskLevelColumn = 'RiskLevel';
ChurnTemplateConstants.RiskLevels = ['Low', 'Medium', 'High'];
ChurnTemplateConstants.RiskLevelOther = 'Unknown';
ChurnTemplateConstants.RiskCountColumn = 'RiskCount';
ChurnTemplateConstants.RiskLow = 0.65;
ChurnTemplateConstants.RiskHigh = 0.85;
ChurnTemplateConstants.SegmentSummaryOutput = 'Segment Summary';
ChurnTemplateConstants.ChurnSegmentColumn = 'ChurnSegment';
ChurnTemplateConstants.ChurnSegmentTotalColumn = 'ChurnSegmentTotal';
ChurnTemplateConstants.ChurnSegmentChurnedColumn = 'ChurnSegmentChurned';
ChurnTemplateConstants.HistoricalSummaryOutput = 'Historical Summary';
ChurnTemplateConstants.HistoricalChurnedColumn = 'HistoricalChurned';
ChurnTemplateConstants.HistoricalChurnCountColumn = 'HistoricalChurnCount';
ChurnTemplateConstants.PredictionSummaryOutput = 'Prediction Summary';
ChurnTemplateConstants.PredictionValueColumn = 'PredictionValue';
ChurnTemplateConstants.PredictionChurnCountColumn = 'PredictionChurnCount';
ChurnTemplateConstants.PredictionIDColumn = 'PredictionID';
ChurnTemplateConstants.PredictionChurnColumn = 'PredictChurn';
ChurnTemplateConstants.PredictionChurnYesValue = 'Yes';
ChurnTemplateConstants.PredictionChurnNoValue = 'No';
ChurnTemplateConstants.PredictionChurnPctColumn = 'PredictChurnPct';
ChurnTemplateConstants.PredictionChurnProbabilityColumn = 'Probability';
ChurnTemplateConstants.PredictionOutput = 'Prediction';
ChurnTemplateConstants.HistoricalPredictionOutput = 'Historical Prediction';
ChurnTemplateConstants.HistoricalPredictionChurnedColumn = 'Churned';
ChurnTemplateConstants.DataElementID = '2HcI0-LbfnpieQ';
ChurnTemplateConstants.RenameElementID = 'W7JXzfY8_IYDrg';
ChurnTemplateConstants.PredictionConditionElementID = 'MygHFgp3TaRkWQ';
ChurnTemplateConstants.HistoricalConditionElementID = 'b-wkOBEMb8K6Fw';
// todo: link this up to the actual data?
ChurnTemplateConstants.BasePredictionOutput = 'Base Prediction';
//# sourceMappingURL=churnTemplateConstants.js.map